import {
  GET_TRACKINGS,
  GET_TRACKINGS_SUCCESS,
  GET_TRACKINGS_ERROR,
  GET_TRACKING,
  GET_TRACKING_SUCCESS,
  GET_TRACKING_ERROR,
  ADD_TRACKING,
  ADD_TRACKING_SUCCESS,
  ADD_TRACKING_ERROR,
  EDIT_TRACKING,
  EDIT_TRACKING_SUCCESS,
  EDIT_TRACKING_ERROR,
  DELETE_TRACKING,
  DELETE_TRACKING_SUCCESS,
  DELETE_TRACKING_ERROR,
  RESET_TRACKING_FLAG,
  SAVE_TRACKING_KEYWORD,
  SET_TRACKING_PAGE,
  SET_TRACKING_TOTAL_PAGE,
  RESET_TRACKING_DATA,
} from "./actionTypes"

const initialState = {
  tracking: null,
  trackings: [],
  error: "",
  success: "",
  loading: false,
  loadingSubmit: false,
  keyword: "",
  page: 1,
  totalPage: 1,
}

const trackings = (state = initialState, action) => {
  switch (action.type) {
    case GET_TRACKINGS:
      state = { ...state, loading: true }
      break
    case GET_TRACKINGS_SUCCESS:
      state = { ...state, trackings: action.payload.trackings, loading: false }
      break
    case GET_TRACKINGS_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_TRACKING:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_TRACKING_SUCCESS:
      state = { ...state, tracking: action.payload.tracking, loading: false }
      break
    case GET_TRACKING_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        tracking: null,
      }
      break
    case ADD_TRACKING:
      state = { ...state, loadingSubmit: true }
      break
    case ADD_TRACKING_SUCCESS:
      state = { ...state, success: action.payload, loadingSubmit: false }
      break
    case ADD_TRACKING_ERROR:
      state = { ...state, error: action.payload, loadingSubmit: false }
      break
    case EDIT_TRACKING:
      state = { ...state, loadingSubmit: true }
      break
    case EDIT_TRACKING_SUCCESS:
      state = { ...state, success: action.payload, loadingSubmit: false }
      break
    case EDIT_TRACKING_ERROR:
      state = { ...state, error: action.payload, loadingSubmit: false }
      break
    case DELETE_TRACKING:
      state = { ...state, loadingSubmit: true }
      break
    case DELETE_TRACKING_SUCCESS:
      state = { ...state, success: action.payload, loadingSubmit: false }
      break
    case DELETE_TRACKING_ERROR:
      state = { ...state, error: action.payload, loadingSubmit: false }
      break
    case SAVE_TRACKING_KEYWORD:
      state = { ...state, keyword: action.payload }
      break
    case SET_TRACKING_PAGE:
      state = { ...state, page: action.payload }
      break
    case SET_TRACKING_TOTAL_PAGE:
      state = { ...state, totalPage: action.payload }
      break
    case RESET_TRACKING_FLAG:
      state = { ...state, success: "", error: "" }
      break
    case RESET_TRACKING_DATA:
      state = { ...state, tracking: null }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default trackings
